<template>
    <VContent>
        <MyRegistrationC :get="get" :post="post" :eventId="this.eventId" :event="event.event" :division="event.skus[0]" />
    </VContent>
</template>

<script>
  import {
    mapMutations,
    mapActions,
    mapState
  } from 'vuex'
  import MyRegistrationC from "@/components/registration/MyRegistrationC";

  export default {
    components: {MyRegistrationC},
    name: "MyRegistration",
    data() {
      return {}
    },
    computed:{
      ...mapState(['eventId','event'])
    },
    beforeMount(){
      let l = this.$store.getters['cognito/isLoggedIn'];
      if(!l){
        this.$router.push('/')
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['get','post'])
    }
  }
</script>

<style scoped>

</style>